import {
  DELETE,
  GET,
  POST,
  PUT,
} from "../../apiController";

const endpoint = "/admin/courses";

// get all courses
export const courses_api = () => {
  return GET(endpoint + `/courses_api`, { _ts: Date.now() });
};

// delete course
export const courseDelete = (data) => {
  return DELETE(endpoint + `/course/${data.course_id}`);
};

// send approval course
export const sendApprovalCourse = (data) => {
  return POST(endpoint + `/send_approval_course`, data);
};

// cancel approval course
export const cancelApprovalCourse = (data) => {
  return POST(endpoint + `/cancel_approval_course`, data);
};

export const publishCourse = (data) => {
  return POST(endpoint + `/publish_course`, data);
};

export const renameCourse = (courseId, courseName) => {
  return PUT(endpoint + `/course/${courseId}/name`, { course_name: courseName });
};

export const generateCourseShareUrl = (data) => {
  return POST(`/org/generate_share_url`, data);
};
